import { Construction } from 'lucide-react'
import { EmptyState } from '@/components/ui/EmptyState'

interface ComingSoonProps {
  title: string
  description: string
}

export function ComingSoon({ title, description }: ComingSoonProps) {
  return (
    <div className="fade-in">
      <div className="page-header">
        <h1>{title}</h1>
      </div>
      <EmptyState
        icon={<Construction size={28} />}
        title="Coming soon"
        description={description}
      />
    </div>
  )
}
